module.exports = __webpack_public_path__ + "media/virtualStagingSlider/virtualStagingSlider3Post-5a3798c9.jpeg";